const schema = {
    competence: {
        id: 'competence',
        label: 'Competência',
        placeholder: '',
        type: 'date',
        required: true,
    },
    nf: {
        id: 'nf',
        label: 'N° da nota fiscal',
        placeholder: '',
        type: 'text',
        required: true,
    },
    status: {
        id: 'status',
        label: 'Status da fatura',
        type: 'select',
        value: '0',
        required: true,
    },
    contracts: {
        id: 'contracts',
        label: 'Contrato(s) selecionado(s)',
        placeholder: '',
        type: 'select',
        required: true,
    },
    contractsGroup: {
        id: 'contractsGroup',
        label: 'Grupo(s) de Contrato(s) selecionado(s)',
        placeholder: '',
        type: 'select',
        required: false,
    },
    tipoSelecao: {
        id: 'tipoSelecao',
        label: 'Tipo de resultado',
        required: true,
        disabled: false,
        type: 'radio',
        value: '1',
        lookup: 'Contrato(s)',
        options: [
            {
                codigo: '1',
                nome: 'Por contrato',
            },
            {
                codigo: '2',
                nome: 'Por grupo de contrato',
            },
        ],
    },
};

export default schema;
